import { useState } from "react";
import { supabase } from "../../supabase";
import { Btn } from "../../components/ui";

const ChangePasswordForm = () => {
  const [currentPassword, setCurrentPassword] = useState("");
  const [newPassword, setNewPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChange = async () => {
    setError("");
    if (!currentPassword || !newPassword || !confirmPassword) { setError("All fields are required."); return; }
    if (newPassword.length < 8) { setError("Password must be at least 8 characters."); return; }
    if (!/[A-Z]/.test(newPassword)) { setError("Password must include an uppercase letter."); return; }
    if (!/[a-z]/.test(newPassword)) { setError("Password must include a lowercase letter."); return; }
    if (!/[0-9]/.test(newPassword)) { setError("Password must include a number."); return; }
    if (newPassword !== confirmPassword) { setError("New passwords do not match."); return; }
    setLoading(true);
    // Verify current password by re-authenticating
    const { data: { user } } = await supabase.auth.getUser();
    const { error: signInErr } = await supabase.auth.signInWithPassword({ email: user.email, password: currentPassword });
    if (signInErr) { setError("Current password is incorrect."); setLoading(false); return; }
    const { error: updateErr } = await supabase.auth.updateUser({ password: newPassword });
    if (updateErr) { setError(updateErr.message); setLoading(false); return; }
    setSuccess(true);
    setCurrentPassword("");
    setNewPassword("");
    setConfirmPassword("");
    setLoading(false);
    setTimeout(() => setSuccess(false), 3000);
  };

  return (
    <div style={{ background: "var(--surface)", border: "1px solid var(--border)", borderRadius: "var(--radius)", padding: 22 }}>
      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        <div>
          <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Current Password</label>
          <input type="password" value={currentPassword} onChange={e => setCurrentPassword(e.target.value)} placeholder="Current password" autoComplete="off" />
        </div>
        <div>
          <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>New Password</label>
          <input type="password" value={newPassword} onChange={e => setNewPassword(e.target.value)} placeholder="New password (min. 6 characters)" autoComplete="off" />
        </div>
        <div>
          <label style={{ fontFamily: "var(--font-mono)", fontSize: "10px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.08em", display: "block", marginBottom: 6 }}>Confirm New Password</label>
          <input type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} placeholder="Confirm new password" autoComplete="off" />
        </div>
        {error && <p style={{ color: "var(--red)", fontSize: "13px", fontFamily: "var(--font-mono)" }}>{error}</p>}
        {success && <p style={{ color: "var(--green)", fontSize: "13px", fontFamily: "var(--font-mono)" }}>✓ Password updated successfully</p>}
        <Btn small onClick={handleChange} disabled={loading}>{loading ? "Updating…" : "Update Password"}</Btn>
      </div>
    </div>
  );
};

export default ChangePasswordForm;
